<template>
  <template v-if="options.length > 0">
    <template v-for="(option, index) in options">

      <div v-if="parseInt(confirmDeleteOptionId) === parseInt(option.id)" class="alert alert-danger text-center mb-1">
        <h4 class="mb-4">Option #{{ (index + 1) }}{{ option.text.length > 0 ? ' "' + option.text + '"' : '' }} deletion confirmation</h4>

        You are about to delete option #{{ (index + 1) }}{{ option.text.length > 0 ? ' "' + option.text + '"' : '' }}.
        If there are any saved records in the smartlist with this option selected, they will all be zeroed out.
        This action cannot be undone.

        <div class="mt-4">
          <button @click="confirmDeleteOptionId = 0" class="btn btn-sm btn-default m-1"><i class="fa fa-fw fa-ban"></i> Cancel</button>
          <button @click="deleteOption(index)" class="btn btn-sm btn-danger m-1"><i class="fa fa-fw fa-remove"></i> Confirm option deletion</button>
        </div>
      </div>

      <div class="row mb-1">
        <div class="col-sm-9">
          <input type="text" v-model="option.text" :placeholder="'Enter option #' + (index + 1) + '...'" class="form-control form-control-sm">
          <span v-if="!isValid && errors[option.id]" class="small text-danger">{{ errors[option.id] }}</span>
        </div>
        <div class="col-sm-3 text-right">
          <button class="btn btn-sm btn-default" @click="confirmOrDeleteOption(option, index)"><i class="fa fa-remove"></i></button>
        </div>
      </div>

    </template>
  </template>

  <button class="btn btn-sm btn-block btn-default" @click="add"><i class="fa fa-plus"></i> Add option</button>

  <div class="form-check mt-2">
    <input v-model="multiple" class="form-check-input" type="checkbox" :id="'allow-multiple' + (isNew ? '-new' : '')">
    <label class="form-check-label" :for="'allow-multiple' + (isNew ? '-new' : '')">
      Allow multiple selection
    </label>
  </div>

  <div v-if="!isValid && errors.common" class="small text-danger mt-2">{{ errors.common }}</div>
</template>

<script>
  export default {
    emits: ['update:value', 'update:valid'],

    props: {
      value: {
        type: Object,
        default: () => {return {}}
      },
      valid: {
        type: Boolean,
        default: true,
      },
      isNew: {
        type: Boolean,
        default: false,
      },
      existingField: {
        type: Boolean,
        default: false,
      },
    },

    data: function () {
      return {
        multiple: this.value.multiple !== undefined ? this.value.multiple : false,
        options: this.value.options !== undefined ? this.value.options : [],
        existingOptionIds: _.cloneDeep((this.value.options !== undefined ? this.value.options : []).map(o => o.id)),
        isValid: this.valid,
        baseOptionId: 0,
        errors: {},
        confirmDeleteOptionId: 0,
      }
    },

    methods: {

      /**
       * This method is required for all settings components.
       */
      validate() {
        this.errors = {};

        // Common validation.
        if (this.options.length === 0) this.errors.common = 'Options are required';
        const hasDuplicates = (arr) => arr.length !== new Set(arr).size;
        if (hasDuplicates(this.options.map(option => option.text))) this.errors.common = 'Options contain duplicates';

        // Option level validation.
        this.options.forEach(option => {
          if (option.text.trim().length === 0) this.errors[option.id] = 'Option text is required';
        });

        this.isValid = Object.keys(this.errors).length === 0;
        this.$emit('update:valid', this.isValid);
      },

      add() {
        this.options.push({
          id: this.nextId,
          text: '',
        });
        this.baseOptionId = this.nextId;
      },

      confirmOrDeleteOption(option, index) {
        if (this.existingField) {
          if (this.existingOptionIds.filter(oid => parseInt(oid) === parseInt(option.id)).length > 0) {
            this.confirmDeleteOptionId = option.id;
            return;
          }
        }
        this.deleteOption(index);
      },

      deleteOption(index) {
        this.options.splice(index, 1);
      },

    },

    computed: {

      nextId() {
        return this.baseOptionId + 1;
      },

    },

    mounted() {
      if (this.options.length > 0) {
        this.baseOptionId = Math.max(...this.options.map(o => o.id));
      }
    },

    watch: {
      options: {
        handler(val) {
          this.$emit('update:value', {
            'options': val,
            'multiple': this.multiple,
          });
        },
        deep: true
      },
      multiple: {
        handler(val) {
          this.$emit('update:value', {
            'options': this.options,
            'multiple': val,
          });
        }
      },
    },
  }
</script>
